import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { I18N, PhoneNumberInputIntl } from 'commons';

const MobilePhoneSection = ({
  values,
  touched,
  errors,
  phoneEditable,
  phoneMandatory,
  phonePrompt,
  phoneValidate,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  isEnableCountryCodeForMemberPortal,
  countries,
  selectedCountries,
  hasUnsupportedCountrycode,
  setHasUnsupportedCountrycode
}) => {
  const { mobilePhone, mobilePhoneCountryCode } = values;
  const hasTouched = _.has(touched, 'mobilePhone');
  const hasError = _.has(errors, 'mobilePhone');

  return (
    <div className="col-md-8">
      <div className="label col-form-label" id="mobilePhoneLabel">

        {phonePrompt}
        {
          phoneMandatory &&
          <span aria-hidden="true" className="required-star">*</span>
        }
        {
          phoneMandatory &&
          <span className="sr-only"><I18N>information.label.required</I18N></span>
        }
      </div>
      <div>
        <PhoneNumberInputIntl
          isEnableCountryCodeForMemberPortal={isEnableCountryCodeForMemberPortal}
          setFieldError={setFieldError}
          inputName="mobilePhone"
          hasTouched={hasTouched}
          errors={errors}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          onChangeCallback={() => { }}
          setIsNeedValidation={() => { }}
          isSignUp
          signUpCountries={countries}
          signUpSelectedCountries={selectedCountries}
          setIscallOutMsgShow={() => { }} // only apply for SMS
          autocomplete="work tel-national"
          itemProperty={{
            noValidate: phoneValidate,
            value: mobilePhone,
            pathType: 'PHONE',
            mandatory: phoneMandatory,
            number: mobilePhone,
            pathId: 'mobilePhone',
            editable: phoneEditable,
            countryCode: mobilePhoneCountryCode
          }}
          pathLabel={phonePrompt}
        />
      </div>
    </div>
  );
};

MobilePhoneSection.propTypes = {
  phoneEditable: PropTypes.bool.isRequired,
  phoneMandatory: PropTypes.bool.isRequired,
  phonePrompt: PropTypes.string.isRequired,
  values: PropTypes.shape().isRequired,
  phoneValidate: PropTypes.bool.isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  isEnableCountryCodeForMemberPortal: PropTypes.bool.isRequired,
  countries: PropTypes.arrayOf(PropTypes.array).isRequired,
  selectedCountries: PropTypes.arrayOf(PropTypes.array).isRequired,
  hasUnsupportedCountrycode: PropTypes.shape().isRequired,
  setHasUnsupportedCountrycode: PropTypes.func.isRequired,
};

export default MobilePhoneSection;
